<template>
  <div>

    <div class="mb-12">
        <div class="page-title mb-2">
          แบบฟอร์มความต้องการเทคโนโลยี
          <span class="page-end-title">(Requirement Form)</span>
        </div>

        <StatusStep
            :current-step="currentStep"
            :steps="documentSteps"
        ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <FormGeneral :masterData="masterData" :form-data="formGeneral" v-if="currentStep == 1"></FormGeneral>
      <FormBusiness :masterData="masterData" :form-data="formBusiness" v-if="currentStep == 2"></FormBusiness>
      <FormIssuesAndNeeds :masterData="masterData" :form-data="formIssuesAndNeeds" v-if="currentStep == 3"></FormIssuesAndNeeds>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="$router.push({ name: 'RequirementList' })">ยกเลิก</Button>

      <div class="flex-center">
        <Button theme="3" min-width="120px" :masterData="masterData" @onClick="backForm">&lt; ย้อนกลับ</Button>
        <Button theme="4" min-width="120px" :masterData="masterData" @onClick="saveDraft">บันทึกฉบับร่าง</Button>
        <Button theme="3" min-width="120px" :masterData="masterData" @onClick="nextForm">ถัดไป ></Button>
      </div>
    </div>

  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep"
import Button from "../../components/input/Button"

import FormGeneral from "./FormGeneral"
import FormBusiness from "./FormBusiness"
import FormIssuesAndNeeds from "./FormIssuesAndNeeds"
import { eventBus } from "../../plugins/global-funcs"

export default {
  name: "RequirementForm",
  components: {
    StatusStep,
    Button,
    FormGeneral,
    FormBusiness,
    FormIssuesAndNeeds
  },
  data () {
    return {
      currentStep: 1,
      documentSteps: [
        {
          no: 1,
          name: 'ข้อมูลทั่วไป'
        },
        {
          no: 2,
          name: 'ข้อมูลการประกอบการ'
        },
        {
          no: 3,
          name: 'ประเด็นปัญหาและความต้องการ'
        }
      ],
      formGeneral: {},
      formBusiness: {},
      formIssuesAndNeeds: {},
      draftId: null,
      masterData: {}
    }
  },
  created () {
    if(this.$route.params.id) {
      this.retrieveForms();
    }else{
      this.createForm()
    }

    eventBus.$on('requirementFormGeneralSend', (form) => {
      this.formGeneral = form
      console.log('FormGeneral data: ', this.formGeneral)
    })

    eventBus.$on('requirementFormBusinessSend', (form) => {
      this.formBusiness = form
      console.log('FormBusiness data: ', this.formBusiness)
    })

    eventBus.$on('requirementFormIssuesAndNeedsSend', (form) => {
      this.formIssuesAndNeeds = form
      console.log('FormIssuesAndNeeds data: ', this.formIssuesAndNeeds)
    })
  },
  methods: {
    backForm () {
      if (this.currentStep <= 1) return;
      this.saveDraft()
      this.currentStep -= 1
      this.$vuetify.goTo('#app')
    },
    nextForm () {
      if (this.currentStep >= this.documentSteps.length) {
        this.saveDraft()
        return this.$router.push({ name: 'RequirementPreview' })
      }
      this.saveDraft()
      this.currentStep += 1
      this.$vuetify.goTo('#app')
    },
    async saveDraft () {
      this.requestForm(this.currentStep)

      //convert this.formIssuesAndNeeds.p3_issue_and_req to string if it's an array
      if (Array.isArray(this.formIssuesAndNeeds.p3_issue_and_req)){
        this.formIssuesAndNeeds.p3_issue_and_req = JSON.stringify(this.formIssuesAndNeeds.p3_issue_and_req)
      }

      let payload = {
        ...this.formGeneral,
        ...this.formBusiness,
        ...this.formIssuesAndNeeds,
        doc_no: '123123', // require field
        doc_status: 'Draft' // require field
      }
      // Add the ID to the payload if it exists
      if (this.draftId) {
        payload.id = this.draftId
      }

      console.log('payload: ', payload)
      // Check if the form has an ID
      if (payload.id) {
        console.log('update draft')
        await this.updateDraft(payload)
      } else {
        console.log('save draft')
        let res = await this.$apiFire('Requirement/saveRequirementForm', payload)
        // console.log(res)
        // Update the form's ID after saving
        this.draftId = res.id
      }

      //convert this.formIssuesAndNeeds.p3_issue_and_req back to array if it's a string
      if (typeof this.formIssuesAndNeeds.p3_issue_and_req === 'string'){
        this.formIssuesAndNeeds.p3_issue_and_req = JSON.parse(this.formIssuesAndNeeds.p3_issue_and_req)
      }

    },

    async updateDraft (payload) {
      let res = await this.$apiFire('Requirement/updateRequirementForm', payload)
      console.log(res)
    },
    requestForm (formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit('requirementFormGeneral')
          break

        case 2:
          eventBus.$emit('requirementFormBusiness')
          break

        case 3:
          eventBus.$emit('requirementFormIssuesAndNeeds')
          break
      }
    },
    async createForm(){
      let res = await this.$apiFire('Requirement/createRequirementForm')
      console.log(res)
      if (res) {
        this.masterData = res
      }
    },
    retrieveForms () {
      // Retrieve the form data
      this.$apiFire('Requirement/getRequirementFormById', { id: this.$route.params.id }).then(res => {
        console.log('getRequirementFormById: ', res)
        if (res) {
          this.masterData = res.masterData
          this.draftId = res.requirementForm.id

          //set this.formGeneral = res.requirementForm's object name start with p1_
          this.formGeneral = Object.keys(res.requirementForm).reduce((obj, key) => {
            if (key.startsWith('p1_')) {
              obj[key] = res.requirementForm[key]
            }
            return obj
          }, {})

          //set this.formBusiness = res.requirementForm's object name start with p2_
          this.formBusiness = Object.keys(res.requirementForm).reduce((obj, key) => {
            if (key.startsWith('p2_')) {
              obj[key] = res.requirementForm[key]
            }
            return obj
          }, {})

          //set this.formIssuesAndNeeds = res.requirementForm's object name start with p3_
          this.formIssuesAndNeeds = Object.keys(res.requirementForm).reduce((obj, key) => {
            if (key.startsWith('p3_')) {
              obj[key] = res.requirementForm[key]
            }
            return obj
          }, {})
        }
      })
      // General form
      eventBus.$on('requirementFormGeneralSend', (form) => {
        this.formGeneral = form
        // clear org data on same address case
        if (form.p1_same_addr) {
          this.formGeneral.p1_org_addr = undefined
          this.formGeneral.p1_org_pid = undefined
          this.formGeneral.p1_org_did = undefined
          this.formGeneral.p1_org_sdid = undefined
          this.formGeneral.p1_org_postcode = undefined
          this.formGeneral.p1_org_phone = undefined
          this.formGeneral.p1_org_mobile_phone = undefined
          this.formGeneral.p1_org_fax = undefined
          this.formGeneral.p1_org_email = undefined
          this.formGeneral.p1_org_website = undefined
        }
        // keep in storage
        this.$store.commit('Requirement/setGeneralForm', this.formGeneral)
      })

      // Business form
      eventBus.$on('requirementFormBusinessSend', (form) => {
        this.formBusiness = form
        // keep in storage
        this.$store.commit('Requirement/setBusinessForm', this.formBusiness)
      })

      // IssuesAndNeeds form
      eventBus.$on('requirementFormIssuesAndNeedsSend', (form) => {
        this.formIssuesAndNeeds = form
        // keep in storage
        this.$store.commit('Requirement/setIssuesAndNeedsForm', this.formIssuesAndNeeds)
      })
    }
  },
  beforeDestroy () {
    eventBus.$off('requirementFormGeneralSend')
    eventBus.$off('requirementFormBusinessSend')
    eventBus.$off('requirementFormIssuesAndNeedsSend')
  },

}
</script>

<style scoped>

</style>